
<div class="wrapper-reponsive">
    <!-- Start màn 4 -->
    <div class="tlt-green-row mt-3">
        {{'STR_CONSUL_INFO_INPUT' | translate}}
    </div>
    <div class="content-box mt-2 mb-2">
        <p class="p-2">
            {{'STR_CONSUL_INFO_NOTE1' | translate}}<br>
            {{'STR_CONSUL_INFO_NOTE2' | translate}}<br>
            {{'STR_CONSUL_INFO_NOTE3' | translate}}<br>
        </p>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_MEDICAL_EXAM_INSTITUTION' | translate }}
                </div>
                <span>{{HTOrgName}}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_RECEPT_DAY'| translate }}
                    <div class="mark-right">{{'STR_REQUIRED' | translate }}</div>
                </div>
                <app-date-inp [strDate]="ReceptDay" (eInp)="RemoveCommon('ReceptDay')" [ngClass]="{'error-border': isReceptDay}" (eRemove)="removeBoder2($event)" (evReturn)="ChangeDOB($event)"></app-date-inp>
                <div *ngIf="isReceptDay" class="err-validate">
                    <span>{{messErr | translate}}</span>
                </div>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_CONSULT_NUM' | translate }}
                    <div class="mark-right">{{'STR_REQUIRED' | translate }}</div>
                </div>
                <input type="text" numberOnly [ngClass]="{'error-border': isConSulNum }" (keyup)="removeErr(2)" [(ngModel)]="ConSulNum" maxlength="3" class="form-control">
                <div *ngIf="isConSulNum" class="err-validate">
                    <span>{{messErr2 | translate}}</span>
                </div>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_CONSULT_ID' | translate }}
                    <div class="mark-right">{{'STR_REQUIRED' | translate }}</div>
                </div>
                <input type="text" numberOnly maxlength="10" [ngClass]="{'error-border': isConSulID }" (keyup)="removeErr(3)" [(ngModel)]="ConSulID" class="form-control">
                <div *ngIf="isConSulID" class="err-validate">
                    <span>{{messErr3 | translate}}</span>
                </div>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-4">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_DATEOFBIRTH' | translate }}
                    <div class="mark-right">{{'STR_REQUIRED' | translate }}</div>
                </div>
                <app-date-inp [strDate]="DateOfBirth" (eInp)="RemoveCommon('DateOfBirth')" [ngClass]="{'error-border': isDateOfBirth}" (evReturn)="ChangeDOB1($event)" (eRemove)="removeBoder($event)"></app-date-inp>
                <div *ngIf="isDateOfBirth" class="err-validate">
                    <span>{{messErr4 | translate}}</span>
                </div>
            </div>
        </div>
        <div class="text-center mt-2">
            <button class="btn btn-common btn-bg-green" (click)="submit()">
                {{'STR_BTN_THE_NEXT' | translate }}
            </button>
        </div>
    </div>
    <!-- End màn 4 -->
</div>

